import { Component, OnInit } from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database';
import { AuthService } from '../../service/auth.service';
import { Auth } from '../../service/auth';

@Component({
	selector: 'app-division-worksheet',
	templateUrl: './division-worksheet.component.html',
	styleUrls: ['./division-worksheet.component.css']
})
export class DivisionWorksheetComponent implements OnInit {

	model: any = { 'theCheckbox': false };
	TimeList: Auth[];
	searchText;
	order: string = 'time';
	reverse: boolean = false;

	numberProblem: number;
	digitsNo1: number;
	digitsNo2: number;
	questions = [];
	currentStudentToken;

	list = [];
	list1 = [];
	list2 = [];
	list3 = [];
	list4 = [];
	list5 = [];
	list6 = [];
	result = [];

	worksheet = false;

	score: number;
	total: number;
	counter;
	seconds;
	allowcatedSeconds;
	interval;
	theCheckbox = false;
	positiveAnswerbox = false;
	color = [];
	submittedAnswers = false;
	answerSheet = false;
	resultSheet = false;
	progress;

	timeStarted = false;
	disappaer = false;

	today = new Date();
	dd = String(this.today.getDate()).padStart(2, '0');
	mm = String(this.today.getMonth() + 1).padStart(2, '0');
	yyyy = this.today.getFullYear();

	constructor(public authService: AuthService,
		private db: AngularFireDatabase) { }

	ngOnInit() {
		this.score = 0;
		for (let i = 5; i <= 100; i += 5) {
			this.questions.push(i);
		}
		this.tokenStudentRegister();
		this.getTime();
	}

	tokenStudentRegister() {
		this.currentStudentToken = localStorage.getItem("currentStudentToken")
	}

	getTime() {
		const s = this.authService.getTimeList();
		s.snapshotChanges().subscribe(data => {
			this.TimeList = [];
			data.forEach(item => {
				const a = item.payload.toJSON();
				a['$key'] = item.key;
				this.TimeList.push(a as Auth);

			});
		});
	}

	randomIntFromInterval1(min, max) {
		return Math.floor(Math.random() * (max - min + 1) + min);
	}
	randomIntFromInterval2(min, digitsNo2) {
		return Math.floor(Math.random() * (digitsNo2 - min + 1) + min);
	}

	continue() {
		var hms = this.model.counter;
		var a = hms.split(':');
		this.allowcatedSeconds = (+a[0]) * 60 * 60 + (+a[1]) * 60 + (+a[2]);
		this.seconds = (+a[0]) * 60 * 60 + (+a[1]) * 60 + (+a[2]);

		if (this.model.theCheckbox === false) {
			this.interval = setInterval(() => {
				this.seconds--;
				if (this.seconds > 0) {
					this.timeStarted = true;
					if (this.seconds === 0) {
						this.disappaer = true;
					}
				}
			}, 1000)
		} else {
			this.interval = setInterval(() => {
				if (this.seconds > 0) {
					this.timeStarted = true;
					this.seconds--;
					if (this.seconds === 0) {
						this.disappaer = true;
						clearInterval(this.interval);
						this.onSubmit();
					}
				}
			}, 1000);
		}
		this.worksheet = true;
		window.scroll(0, 0);
		for (let i = 0; i < this.model.numberProblem; i++) {
			this.list.push(i);
			const j = this.randomIntFromInterval2(1, this.model.digitsNo2);
			this.list2.push(j)
			const x = Math.floor(this.model.digitsNo1 / this.list2[i])
			this.list6[i] = this.randomIntFromInterval1(1, x);
			const z = this.list6[i] * this.list2[i];
			this.list5.push(z)
		}
		this.total = this.model.numberProblem;
	}

	onSubmit() {
		this.submittedAnswers = true;
		window.scroll(0, 0);
		this.pauseTimer();
		for (let i = 0; i < this.model.numberProblem; i++) {
			if (this.result[i] == this.list6[i]) {
				this.color[i] = 'green';
				this.score = this.score + 1;
			}
			if (this.result[i] != this.list6[i]) {
				this.color[i] = 'red';
			}
			if (this.result[i] == undefined) {
				this.result[i] = this.list6[i];
				this.color[i] = 'red';
			}
		}
	}

	onProgress() {
		this.resultSheet = true;
		window.scroll(0, 0);
		this.addDatabase();
	}

	addDatabase() {
		this.progress = (this.score / this.total) * 100;
		this.db.list('student_quiz').push({
			userId: this.currentStudentToken,
			date: this.mm + '-' + this.dd + '-' + this.yyyy,
			operator: 'Division',
			allocatedTime: this.allowcatedSeconds,
			consumeTime: this.allowcatedSeconds - this.seconds,
			totalQuiz: this.total,
			score: this.score,
			precentage: this.progress
		});
	}


	startTimer() {
		this.interval = setInterval(() => {
			this.seconds--;
			if (this.seconds > 0) {
				this.timeStarted = true;
				if (this.seconds === 0) {
					this.disappaer = true;
				}
			}
		}, 1000)
	}

	pauseTimer() {
		this.timeStarted = false;
		clearInterval(this.interval);
	}

}